import React from 'react';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';

import { ACTIVITY } from 'graphql/queries/activities';

import {
  ACTIVITY_SCHEDULE_FORMS_NUMBERS,
  ACTIVITY_PRICES_FORMS_NUMBERS
} from 'pages/create-activity/constants';

import ConfirmContext from 'contexts/ConfirmContext';

import { getReceivedActivityData } from 'utils/accommodations-and-activities/prepareReceivedActivityData';
import { ACTIVITY_BOOK_DATES } from '../../graphql/queries/activities-bookings';
import { getRange } from '../../utils/book-accommodation/availableDates';

const UpdateActivityWrapper = ({ children, businessOwner }) => {
  const { id } = useParams();
  const confirm = React.useContext(ConfirmContext);
  const history = useHistory();

  const { loading, error, data, refetch, networkStatus } = useQuery(ACTIVITY, {
    variables: {
      activityId: id,
      businessOwnerId:
        businessOwner.selectedBusinessOwner.ownerId ||
        businessOwner.selectedBusinessOwner.id
    },
    notifyOnNetworkStatusChange: true
  });

  React.useEffect(() => {
    refetch();
  }, []);

  const isCopy = () => {
    return window.location.href.search('/copy') >= 0;
  };

  if (loading || networkStatus === 4) {
    return (
      <div style={{ height: '100%' }}>
        {React.cloneElement(children, {
          loading: true,
          isCopy: isCopy(),
          bookDates: []
        })}
      </div>
    );
  }

  if (error || !data.activities.length) {
    if (
      businessOwner &&
      businessOwner.selectedBusinessOwner.hasOwnProperty('id')
    ) {
      confirm({
        title: 'Activity does not exist!',
        confirmationText: 'Back'
      })
        .then(() => history.push('/accommodations-and-activities'))
        .catch(() => {});
    }

    return (
      <div style={{ height: '100%' }}>
        {React.cloneElement(children, {
          loading: false,
          isCopy: isCopy(),
          bookDates: []
        })}
      </div>
    );
  }

  const activity = data.activities[0];

 
  const initialData = getReceivedActivityData(activity);

  const scheduleActiveSubTabNumber =
    ACTIVITY_SCHEDULE_FORMS_NUMBERS[activity.scheduleType];
  let pricesActiveSubTabNumber =
    ACTIVITY_PRICES_FORMS_NUMBERS[scheduleActiveSubTabNumber][
      activity.pricesType
    ];

  if (activity.isOpen) pricesActiveSubTabNumber--;

 

  return (
    <div style={{ height: '100%' }}>
      {React.cloneElement(children, {
        data: initialData,
        scheduleActiveSubTabNumber,
        pricesActiveSubTabNumber,
        existingFutureRatePlanIds: activity?.futurePrices?.map(fp => fp.ratePlan.id) || [],
        loading: false,
        isCopy: isCopy(),
        bookDates:
          activity?.activitybookingSet.reduce(
            (
              acc,
              { startingDate, endingDate, isCanceled, deactivationBooking }
            ) => {
              if (startingDate && endingDate && !isCanceled) {
                return [
                  ...acc,
                  ...getRange(startingDate, endingDate).map(date => ({
                    date,
                    deactivationBooking
                  }))
                ];
              }

              return acc;
            },
            []
          ) || []
      })}
    </div>
  );
};

const mapStateToProps = state => ({
  businessOwner: state.businessOwner
});

export default connect(mapStateToProps, null)(UpdateActivityWrapper);
